import { TaskQueue } from 'owa-task-queue';
import TokenResponse from 'owa-service/lib/contract/TokenResponse';
import { Options } from 'owa-tokenprovider/lib/fetchDelegationAccessTokenFromMsa';
import { fetchDelegationAccessTokenFromMsa } from 'owa-tokenprovider/lib/fetchDelegationAccessTokenFromMsa';

const MAX_NUM_OF_GET_DELEGATION_TOKEN_REQUESTS = 3;
const DELAY_FOR_GET_DELEGATION_TOKEN_REQUESTS = 500; /* Task Delay */

let delegationTokenQueue: TaskQueue<QueueEntry>;

export interface QueueEntry {
    onFulfilled: Function;
    onRejected: Function;
    options: Options;
}

/**
 * This throttles getDelegationTokenForOwa requests
 * by adding a delay of 500 ms
 */
function getDelegationTokenQueue(): TaskQueue<QueueEntry> {
    if (delegationTokenQueue == null) {
        delegationTokenQueue = new TaskQueue<QueueEntry>(
            MAX_NUM_OF_GET_DELEGATION_TOKEN_REQUESTS,
            getDelegationTokenTask,
            DELAY_FOR_GET_DELEGATION_TOKEN_REQUESTS
        );
    }
    return delegationTokenQueue;
}

/**
 * enqueue these options
 * along with a success and an error callback to TaskQueue
 */
export function enqueue(opts: Options): Promise<TokenResponse> {
    let onSuccess: () => void = null;
    let onFailure: () => void = null;
    /* tslint:disable-next-line:promise-must-complete */
    const tokenReponsePromise = new Promise<TokenResponse>(async (resolve, reject) => {
        onSuccess = resolve;
        onFailure = reject;
    });
    let entry: QueueEntry = {
        onFulfilled: onSuccess,
        onRejected: onFailure,
        options: opts,
    };
    getDelegationTokenQueue().add(entry);
    return tokenReponsePromise;
}

export async function getDelegationTokenTask(entry: QueueEntry): Promise<any> {
    fetchDelegationAccessTokenFromMsa(entry.options)
        .then((tokenResponse: TokenResponse) => {
            entry.onFulfilled(tokenResponse);
        })
        .catch(error => {
            entry.onRejected(error);
        });
}
